var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose-state"},_vm._l((_vm.chooses),function(choose,index){return _c('div',{key:choose.name,on:{"click":function($event){return _vm.active(index)}}},[_c('img',{attrs:{"src":index==_vm.inde?_vm.imgUrl2:_vm.imgUrl1,"alt":""}}),_c('span',{class:index==_vm.inde?'choosed':'',domProps:{"textContent":_vm._s(choose.name)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }